import { render } from "./PlainStoryEditor.vue.js?vue&type=template&id=7bb96066!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PlainStoryEditor.vue?vue&type=template&id=7bb96066"
import script from "./PlainStoryEditor.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PlainStoryEditor.vue?vue&type=script&lang=js"
export * from "./PlainStoryEditor.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PlainStoryEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/components/PlainStoryEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7bb96066"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7bb96066', __exports__)) {
    api.reload('7bb96066', __exports__)
  }
  
  module.hot.accept("./PlainStoryEditor.vue.js?vue&type=template&id=7bb96066!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PlainStoryEditor.vue?vue&type=template&id=7bb96066", () => {
    api.rerender('7bb96066', render)
  })

}


export default __exports__